import { render } from "./CadastroPaisView.vue?vue&type=template&id=c6c4bb8c"
import script from "./CadastroPaisView.vue?vue&type=script&lang=js"
export * from "./CadastroPaisView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD25\\Domus Fiança\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__